import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { TableColumnDef } from 'src/app/common/table-column-def';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { SettingLimitParamDialogDto } from './0-defs';

export interface SettingLimitParamData {
  title: string;
  itemCheck: SettingLimitParamDialogDto[];
  itemList: [];
};

@Component({
  selector: 'app-setting-limit-param-dialog',
  templateUrl: './setting-limit-param-dialog.component.html',
  styleUrls: ['./setting-limit-param-dialog.component.css']
})
export class SettingLimitParamDialogComponent implements OnInit {

  public settingLimitParamList: SettingLimitParamDialogDto[];
  public settingLimitParamListReq: SettingLimitParamDialogDto[];
  public settingLimitParamListOrigin: SettingLimitParamDialogDto[];
  public settingLimitParamListDisplay: SettingLimitParamDialogDto[];

  public displayColumnIds: string[] = ["checkBox", "storeCdFv", "itemMakerCd", "itemStoreCd", "itemBrdCd", "itemNameFv", "standardFv", "convFactFv", "minZai", "maxZai", "minStockDays", "maxStockDays"];
  public colDefs: TableColumnDef[] = [
    { columnId: 'checkBox', header: "選択", width: 50, align: "center" },
    { columnId: 'storeCdFv', header: "事業所", width: 40, align: "center" },
    { columnId: 'itemMakerCd', header: 'メーカー', width: 40, align: 'center' },
    { columnId: 'itemStoreCd', header: '連番', width: 30, align: 'center' },
    { columnId: 'itemBrdCd', header: '内訳', width: 20, align: 'center' },
    { columnId: "itemNameFv", header: "商品名", width: 150, align: "left" },
    { columnId: "standardFv", header: "規格", width: 80, align: "center" },
    { columnId: "convFactFv", header: "入数", width: 80, align: "center" },
    { columnId: 'minZai', header: "最低陳列", width: 30, align: "right" },
    { columnId: 'maxZai', header: "最大陳列", width: 60, align: "right" },
    { columnId: 'minStockDays', header: "最低在庫日数", width: 80, align: "right" },
    { columnId: 'maxStockDays', header: "最大在庫日数", width: 80, align: "right" },
  ];
  public tableWidth: any;
  public paginatorMaxWidth: any;
  public recordCount: number = 0;
  @ViewChild(MatPaginator, { static: false }) matPaginator: MatPaginator;

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<SettingLimitParamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SettingLimitParamData,
    private httpBasic: HttpBasicService,
  ) { }

  ngOnInit(): void {
    this.setTableWidth();
    this.settingLimitParamListReq = []
    this.settingLimitParamList = [];
    this.settingLimitParamListOrigin = [];
    if (this.data) {
      this.data.itemCheck.forEach(row => {
        let dto = {
          ...row,
          formChecked: new FormControl(false),
          storeCdFv: row.storeCdFv,
          itemMakerCd: row.itemCdFv.substring(0, 5),
          itemStoreCd: row.itemCdFv.substring(5, 10),
          itemBrdCd: row.itemCdFv.substring(10, 12),
          itemNameFv: row.itemNameFv,
          standardFv: row.standardFv,
          convFactFv: row.convFactFv,
          minZai: row.minZai,
          maxZai: row.maxZai,
          minStockDays: row.minStockDays,
          maxStockDays: row.maxStockDays
        }
        this.settingLimitParamList.push(dto);
      });
      this.data.itemList.forEach(item => {
        this.settingLimitParamListReq.push(item);
      })
      this.settingLimitParamListOrigin = [...this.settingLimitParamList];
      this.pageChanged();
    }
  }

  pageChanged() {
    this.settingLimitParamListDisplay = [];
    this.recordCount = this.settingLimitParamList?.length || 0;
    let start;
    let end;
    if (this.matPaginator) {
      start = this.matPaginator.pageIndex * this.matPaginator.pageSize
      end = start + this.matPaginator.pageSize;
    } else {
      start = 0;
      end = this.commonService.config.pagenatorOptions[0];
    }
    if (end > this.settingLimitParamList.length) end = this.settingLimitParamList.length;
    if (this.settingLimitParamListDisplay?.length == 1) return;
    else this.settingLimitParamListDisplay = this.settingLimitParamList?.slice(start, end);
  }

  styleFor(id: string) {
    for (var colDef of this.colDefs) {
      if (colDef.columnId === id) {
        return {
          "width": "" + colDef.width + "px",
          "text-align": colDef.align ? colDef.align : "left"
        }
      }
    }
  };

  styleForHeader(id: string) {
    for (var colDef of this.colDefs) {
      if (colDef.columnId === id) {
        return {
          "width": "" + colDef.width + "px"
        }
      }
    }
  };

  setTableWidth() {
    var width = 1;   // For left border

    for (var colDef of this.colDefs) {
      width = width + colDef.width + 1 + 8;    // 1 for right border, 8 for padding
    }
    this.tableWidth = { "width": "" + width + "px" };
    this.paginatorMaxWidth = { "max-width": "" + width + "px" };
  };

  doUpdate() {
    let itemList = [];
    const filteredList = this.settingLimitParamListReq.filter(item => {
      // Check if item properties are different from any item in settingLimitParamList
      const isDifferent = !this.settingLimitParamList.some(existingItem =>
        existingItem.storeCdFv === item.storeCdFv && existingItem.itemCdFv === item.itemCdFv
      );

      // Check if item's storeCdFv and itemCdFv are included in itemList
      return isDifferent && itemList.includes(item.storeCdFv) && itemList.includes(item.itemCdFv);
    });

    this.settingLimitParamListReq.filter(rec => {
      let tmp = this.settingLimitParamList.find(row => rec.storeCdFv == row.storeCdFv && rec.itemCdFv == row.itemCdFv);
      if (tmp && !tmp.formChecked.value) return;
      itemList.push(rec);
    })
    let request = {
      access: this.commonService.loginUser,
      limitTimeParamEdit: itemList.concat(filteredList),
      mode: "2"
    }

    this.commonService.openSpinner(this.commonService.pageTitle, "登録中・・・");
    let subsc = this.httpBasic.generalRequest("LimitTimeParamEdit", request).subscribe(
      (response) => {
        subsc.unsubscribe();
        this.commonService.closeSpinner();
        this.receiveSave(response);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinner();
        this.httpBasic.handleError(error);
      }
    );
  };

  receiveSave(response: any) {
    if (this.httpBasic.handleAppError(response)) { return; }
    this.dialogRef.close(response);
  };

  doCancel() {
    this.dialogRef.close();
  };

  selectAll() {
    this.settingLimitParamList.forEach(row => {
      row.formChecked.setValue(true);
    });
  };

  unSelectAll() {
    this.settingLimitParamList.forEach(row => {
      row.formChecked.setValue(false);
    });
  };

  onItemChecked(item: SettingLimitParamDialogDto, checked: boolean) {
    if (checked) {
      this.settingLimitParamList.forEach(row => {
        if (row.storeCdFv == item.storeCdFv && row.itemCdFv == item.itemCdFv) {
          item.formChecked.setValue(true);
        }
      });
    } else {
      this.settingLimitParamList.forEach(row => {
        if (row.storeCdFv == item.storeCdFv && row.itemCdFv == item.itemCdFv) {
          item.formChecked.setValue(false);
        }
      });
    }
  };

  checkUpdateDisable() {
    let isChecked = this.settingLimitParamList.filter(item => item.formChecked.value == true);
    if (isChecked.length > 0) return false;
    return true;
  };
}
